import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { BaseResponse } from '../models'

const _BASE_URL = import.meta.env.REACT_APP_AI_BASE_URL!

export interface FindAndReplaceResponse {
  changeCount: number
  newMeetingSummary: string
  newTitle: string
  aiAgentResultChangeCount: number
  aiResultChangeCount: number
  taskChangeCount: number
  roomTitleChangeCount: number
}

interface FindAndReplaceRequest {
  accountId: string
  roomId: string
  sessionId: string
  payload: {
    meetingTemplateId: string
    find: string
    replace: string
  }
}

export const findAndReplaceApi = createApi({
  reducerPath: 'findAndReplace',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['FindAndReplace'],
  endpoints: (builder) => ({
    findAndReplace: builder.mutation<FindAndReplaceResponse, FindAndReplaceRequest>({
      query: (request) => {
        return {
          url: `/accounts/${request.accountId}/rooms/${request.roomId}/sessions/${request.sessionId}/find-and-replace`,
          method: 'POST',
          body: request.payload,
        }
      },
      transformResponse: (response: BaseResponse<FindAndReplaceResponse>) => response.data,
    }),
  }),
})

export const { useFindAndReplaceMutation } = findAndReplaceApi
